import DataroomTenantConfig from '@/dataroom/application/config/DataroomTenantConfig';

const getDataroomBasedUrl = (dataroomName: string, path: string) => {
  const { options: { tenantUrlPrefix } } = DataroomTenantConfig.fromHostname();

  return `/${ tenantUrlPrefix }/${ dataroomName }/${ path }`;
};

export default getDataroomBasedUrl;
